import {Component, forwardRef} from '@angular/core';
import {ToothBaseComponent} from '../../tooth-base.component';

@Component({
  selector: 'app-tooth-26',
  templateUrl: 'tooth-26.component.html',
  providers: [{provide: ToothBaseComponent, useExisting: forwardRef(() => Tooth26Component)}]
})
export class Tooth26Component extends ToothBaseComponent {}
